import ConversationItemSearchHit from 'models/search/conversation_item_search_hit';
import CustomerProfileSearchHit from 'models/search/customer_profile_search_hit';
import HitTypes from 'models/search/hit_types';

export default [
  [HitTypes.CONVERSATION, ConversationItemSearchHit],
  [HitTypes.CUSTOMER_PROFILE, CustomerProfileSearchHit],
];



// WEBPACK FOOTER //
// ./src/scripts/domain/models/search/hit_classes.js